module.exports = __webpack_public_path__ + "img/coupon.433f1704.png";